import Image from "next/image"
import styles from "../upsc-prestorming-prelims-test-series-thankyou/thankyou.module.css";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import Link from "next/link";
import thankyou from "../../assets/images/upsc/thank you.png";

const Prefit_Thankyou = () => {
   
    return (
        <>
        <Navbar title="upsc" />
            <div className="container-fluid " style={{backgroundColor:"#F4F6F8"}}>
                <div className="row">
                    <div className="col py-5 my-md-3">
                        <div className="container">
                            <div className="row">
                                <div className="col px-0 text-center py-5">
                                    <Image src={thankyou} className="img-fluid " alt="Thank you" title="Thank you"/>
                                    <p className={`${styles.thankspara} pt-3`}>Thank you for registering with us.<br/> We will get back to you soon.</p>
                                    <Link href="/upsc-prefit-test"><button className={`${styles.normalbutton}`} >Back</button></Link>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
                

            
    <Footer />

        </>
    )
}

export default Prefit_Thankyou